import React, { useEffect, useState } from "react"
import VesselTrackingMap from "./VesselTrackingMap"
import VesselTrackingInfo from "./VesselTrackingInfo"
import { useFetchList, VesselTrackingList } from "../hooks/useFetchList"
import { useFetchVesselInfo } from "../hooks/useFetchVesselInfo"
import { useTrackVessel } from "../hooks/useTrackVessel"
import { useFetchVesselStays } from "modules/Prevetting/hooks/useFetchVesselStays"
import { useFetchVesselPositions4 } from "modules/Prevetting/hooks/useFetchVesselPositions"

function VesselTrackingMain() {
  const {
    vesselTrackingList,
    fetchVesselTrackingList,
    appendVesselTrackingList,
    getVesselListLoading,
  } = useFetchList()
  const [activeList, setActiveList] = useState<VesselTrackingList>()
  const [selectedVesselPosition, setSelectedVesselPosition] = useState<
    [number, number] | null
  >(null)
  const [routeViewImo, setRouteViewImo] = useState<string | null>(null)
  const [statusFilter, setStatusFilter] = useState<string>("all")
  const [loadingFilter, setLoadingFilter] = useState<string>("all")
  const { vesselInfos, fetchVesselInfo, isGetVesselInfoLoading } =
    useFetchVesselInfo()
  const { vesselStaysData, isVesselStaysLoading } = useFetchVesselStays({
    imo: routeViewImo ? Number(routeViewImo) : undefined,
  })

  const routeVesselSegment = routeViewImo
    ? vesselInfos?.find((v) => v.vesselImo === routeViewImo)?.vesselSegment
    : undefined

  const { vesselPositions, vesselPositionsLoading } = useFetchVesselPositions4({
    imo: routeViewImo ? Number(routeViewImo) : undefined,
    segment: routeVesselSegment,
    months: 12,
  })
  const {
    trackVesselDetails,
    trackVessel,
    isTrackVesselLoading,
    clearTrackVesselDetails,
  } = useTrackVessel()
  //fetch initial list
  useEffect(() => {
    fetchVesselTrackingList()
  }, [])

  //set initial active list as prevet list (only when none is selected yet,
  //so appending a new list doesn't yank the user back to the default)
  useEffect(() => {
    if (!activeList && vesselTrackingList && vesselTrackingList.length > 0) {
      setActiveList(
        vesselTrackingList.find(
          (list) => list.listType === "prevet" && list.userId
        )
      )
    }
  }, [vesselTrackingList])

  useEffect(() => {
    if (activeList) {
      fetchVesselInfo([activeList.id])
    }
  }, [activeList])

  useEffect(() => {
    if (vesselInfos && vesselInfos.length > 0) {
      const imos = vesselInfos.map((vessel) => vessel.vesselImo)
      trackVessel(imos)
    } else {
      clearTrackVesselDetails()
    }
  }, [vesselInfos])

  return (
    <>
      {getVesselListLoading ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="VesselTrackingContainer">
          {vesselTrackingList && activeList ? (
            <>
              <VesselTrackingMap
                vesselInfos={vesselInfos}
                fetchVesselInfo={fetchVesselInfo}
                isGetVesselInfoLoading={isGetVesselInfoLoading}
                trackVessel={trackVessel}
                trackVesselDetails={trackVesselDetails}
                isTrackVesselLoading={isTrackVesselLoading}
                clearTrackVesselDetails={clearTrackVesselDetails}
                selectedVesselPosition={selectedVesselPosition}
                routeViewImo={routeViewImo}
                onVesselClickForRoute={(imo) => setRouteViewImo(imo)}
                onClearRouteView={() => setRouteViewImo(null)}
                statusFilter={statusFilter}
                loadingFilter={loadingFilter}
                vesselStays={(() => {
                  if (!vesselStaysData) return []
                  const cutoff = new Date()
                  cutoff.setMonth(cutoff.getMonth() - 12)
                  return vesselStaysData.filter(
                    (s) => new Date(s.date_from) >= cutoff
                  )
                })()}
                vesselPositions = {(() => {
                  if(!vesselPositions) return [] 
                  return vesselPositions
                })()}
                isRouteLoading={isVesselStaysLoading || vesselPositionsLoading}
              />
              <VesselTrackingInfo
                trackingList={vesselTrackingList}
                activeList={activeList}
                setActiveList={setActiveList}
                fetchVesselTrackingList={fetchVesselTrackingList}
                appendVesselTrackingList={appendVesselTrackingList}
                vesselInfos={vesselInfos}
                fetchVesselInfo={fetchVesselInfo}
                isGetVesselInfoLoading={isGetVesselInfoLoading}
                trackVessel={trackVessel}
                trackVesselDetails={trackVesselDetails}
                isTrackVesselLoading={isTrackVesselLoading}
                clearTrackVesselDetails={clearTrackVesselDetails}
                onSelectVessel={(lat, lon) =>
                  setSelectedVesselPosition([lat, lon])
                }
                statusFilter={statusFilter}
                loadingFilter={loadingFilter}
                onStatusFilterChange={setStatusFilter}
                onLoadingFilterChange={setLoadingFilter}
              />
            </>
          ) : (
            <div className="d-flex justify-content-center align-items-center vh-100">
              <h4 className="text-center">
                No Vessel Tracking List Available.
              </h4>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default VesselTrackingMain
